import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { translate } from "application/functions";

export default function Success(props) {
  return (
    <div
      className="success__container"
    >
      <div className="success__message">
        {translate(`success.message`, props.locale)}
      </div>
    </div>
  );
}

Success.propTypes = {
  locale: PropTypes.string,
};
